import React from "react";
import { jwtDecode } from 'jwt-decode'
import Main from "./Components/Main";
import EmbeddedHubspot from "./Embedded/Hubspot/EmbeddedHubspot";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

import { GetTheme, ThemeBackgroundColor, ThemeFontColor, ThemeBorderColor , ThemeHistoryBackgroundColor, ThemeBackgroundColorSlightlyOff, 
  ThemeHistoryBackgroundColorHover, ThemeHistoryBackgroundColorFocus, ThemeHistoryBackgroundColorHoverFocus, ThemeHistoryFontColorFocus, 
  OverrideThemes, OverrideThemesLight, OverrideThemesDark } from "./Components/Themes";
import MakeCall from "./Components/MakeCall";
import Signin from "./Components/Signin";
import SigninGntel from "./Components/SigninGntel";
import { IsEmptyString } from "./Components/GeneralFunctions";
import Cookies from 'js-cookie';
import SpecialEmbeddedBehaviour from "./Components/SpecialEmbeddedBehaviour";
import { SigninApiTokenRefresh } from "./ExternalApi/SigninApi"
import packageJson from '../package.json';

function App() {  
  
  const windowUrl = window.location.search;
  var params = new URLSearchParams(windowUrl);
  const handoverToken = params.get("handover_token")    
  const reset = params.get("reset")
  const action = params.get("action")
  const number = params.get("number")  

  var embedded = "" 
  var brand = ""
  var signinmethod = ""
  if (packageJson.homepage.endsWith("bonlinehubspot") || packageJson.homepage.endsWith("bonlinehubspotbeta"))   
  {
    embedded = "hubspot" 
    brand = "bonline"
    signinmethod = "bonline"
  }
  else
  {
    embedded = params.get("embedded")  
    brand = (params.get("brand") ?? "").toLowerCase() 
    signinmethod = null
  }

  const nonce = params.get("nonce")  
  try { params.delete("handover_token") } catch {}
  try { params.delete("reset") } catch {}
  const WindowUrlWithoutOnetimeParams = window.location.origin + window.location.pathname + (params.size > 0 ? "?" + `${params}` : "") 

  let branding_favicon = ""
  let branding_signinmethod = ""
  let branding_color = "#0f9ddd"
  let branding_color_light = "#d5e6fb"
  let branding_color_dark = "#2b468b"
  let branding_color_selectedtab = "#2f477d"
  let brand_color_textonmain = "#ffffff"
  let branding_productname = "CloudCTI"
  let branding_domain = ".cloudcti.nl"
  let branding_notification_color = "#d4edda"
  let branding_notification_textcolor = "#000000"
  
  let brand_color_callbuttonbackground = "#f8f9fa"
  let brand_color_callbuttonborder = "#aaaaaa"
  let brand_color_callbuttontext = "#000000"
  let brand_color_callbuttonhoverbackground = "#d3d4d5"
  let brand_color_callbuttonhovertext = "#000000"

  let iconwidth = "65px"
  let iconheight = "50px"
  if (window.location.hostname === "webclient.gntel.cloudcti.nl")// || true)
  {
    branding_signinmethod = "gntel"
    branding_color = "#0f9ddd"
    branding_color_light = "#d5e6fb"
    branding_color_dark = "#2b468b"
    branding_productname = "CloudCTI"
    branding_domain = ".cloudcti.nl"
  }
  else if (window.location.hostname === "webcrm.voxone.co.uk")// || true)
  {
    branding_favicon = "favicon_voxone.ico"
    branding_productname = "Voxone"
  }
  else if ((window.location.hostname === "embeddedcrm.contactconnect.enreach.com") || (brand === "enreach"))// || true)
  {
    brand = "enreach"
    branding_favicon = "favicon_enreach.ico"

    branding_signinmethod = "voiceworks"
    branding_productname = "Enreach Connect"
    branding_color = "#8A54B8"
    branding_color_light = "#F9F5FB"
    branding_color_dark = "#6001B5"
    branding_color_selectedtab = "#6001B5"
    branding_domain = ".cloudcti.nl"   
    branding_notification_color = "#E6D7EF"

    brand_color_callbuttonbackground = "#8A54B8"
    brand_color_callbuttonborder = "#6001B5"
    brand_color_callbuttontext = "#ffffff"
    brand_color_callbuttonhoverbackground = "#6001B5"
    brand_color_callbuttonhovertext = "#ffffff"

    iconwidth = "50px"
    iconheight = "50px"
    
    OverrideThemes("#000000", branding_color_light, "#F1EDF4", "#E6D7EF", branding_color_light, branding_color, branding_color, branding_color, branding_color_light, false)
  }
  else if ((window.location.hostname === "embeddedcrm.contactconnect.summa.io") || (brand === "summa")) // || true)
  {
    brand = "summa"
    branding_favicon = "favicon_summa.ico"

    branding_signinmethod = "voiceworks"
    branding_productname = "Contact"
    branding_color = "#197C58"
    branding_color_light = "#EFF9F3"
    branding_color_dark = "#1A5940"
    branding_color_selectedtab = "#1A5940"
    branding_domain = ".cloudcti.nl"   
    branding_notification_color = "#BCE6D0"

    brand_color_callbuttonbackground = "#197C58"
    brand_color_callbuttonborder = "#1A5940"
    brand_color_callbuttontext = "#ffffff"
    brand_color_callbuttonhoverbackground = "#1A5940"
    brand_color_callbuttonhovertext = "#ffffff"
    
    iconwidth = "50px"
    iconheight = "50px"

    OverrideThemes("#000000", branding_color_light, "#E6F0EA", "#CCECDC", branding_color_light, branding_color, branding_color, branding_color, branding_color_light, true)
  }
  else if ((window.location.hostname === "xelion.webclient.cloudcti.nl") || (brand === "xelion")) // || true)
  {
    brand = "xelion"
    //branding_favicon = "favicon_summa.ico"

    if (GetTheme() === "dark")
    {
      branding_color = "#ff6320"
      branding_color_light = "#000000"
      branding_color_dark = "#35373b"
      branding_color_selectedtab = "#2b2d30"
      brand_color_textonmain = "#ffffff"
      branding_notification_color = "#35373b"
      branding_notification_textcolor = "#ffffff"
      
      brand_color_callbuttonbackground = "#ff6320"
      brand_color_callbuttonborder = "#ff6320"
      brand_color_callbuttontext = "#000000"
      brand_color_callbuttonhoverbackground = "#9c4f32"
      brand_color_callbuttonhovertext = "#000000"
    }
    else
    {
      branding_color = "#ff6320"
      branding_color_light = "#ffffff"
      branding_color_dark = "#f2f3f5"
      branding_color_selectedtab = "#f2f3f5"
      brand_color_textonmain = "#000000"
      branding_notification_color = "#f2f3f5"
      branding_notification_textcolor = "#000000"
      
      brand_color_callbuttonbackground = "#ff6320"
      brand_color_callbuttonborder = "#ff6320"
      brand_color_callbuttontext = "#ffffff"
      brand_color_callbuttonhoverbackground = "#ffa47b"
      brand_color_callbuttonhovertext = "#ffffff"
    }
    
    OverrideThemesLight("#000000", "#ffffff", "#f2f3f5", "#dfe2e8", "#ffffff", "#ffffff", "#ff6320", "#ffa47b", "#ffffff", (GetTheme() !== "dark"))
    OverrideThemesDark("#ffffff", "#1c1d1f", "#2b2d30", "#2e3033", "#2b2d30", "#35373b", "#ff6320", "#9c4f32", "#000000", (GetTheme() !== "dark"))
  }
  else if (brand === "bonline")
  {
    branding_signinmethod = "bonline"
    branding_productname = "BOnline"
    branding_color = "#43cccc"
    branding_color_light = "#FFFFFF"
    branding_notification_color = "#FFFFFF"
    iconwidth = "60px"
    iconheight = "60px"
  }
  else if ((embedded ?? "").toLowerCase() === "zendesk")
  {
    branding_notification_color = "#309DFF"
  }

  //Set caption
  document.title = branding_productname + " Webclient"

  // Set override favicon
  if (!IsEmptyString(branding_favicon))
  {
    const faviconURL = packageJson.homepage + "/" + branding_favicon
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = faviconURL;
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  var r = document.querySelector(':root')

  //from branding
  r.style.setProperty('--brand_color', branding_color)
  r.style.setProperty('--brand_color_off', GetTheme() === "dark" ? branding_color_dark : branding_color_light)

  r.style.setProperty('--font_color', ThemeFontColor())
  r.style.setProperty('--border_color', ThemeBorderColor())
  r.style.setProperty('--scrollbar_color', ThemeBorderColor()) //tbd  
  r.style.setProperty('--background_color', ThemeBackgroundColor())
  r.style.setProperty('--background_color_slightlyoff', ThemeBackgroundColorSlightlyOff())
  r.style.setProperty('--selected_tab', branding_color_selectedtab)
  r.style.setProperty('--history_background_color', ThemeHistoryBackgroundColor())
  r.style.setProperty('--history_background_color_hover', ThemeHistoryBackgroundColorHover())
  r.style.setProperty('--history_background_color_focus', ThemeHistoryBackgroundColorFocus())
  r.style.setProperty('--history_background_color_hoverfocus', ThemeHistoryBackgroundColorHoverFocus())
  r.style.setProperty('--history_font_color_focus', ThemeHistoryFontColorFocus())
  r.style.setProperty('--notification_color', branding_notification_color)
  r.style.setProperty('--notification_textcolor', branding_notification_textcolor)
  
  r.style.setProperty('--brand_color_textonmain', brand_color_textonmain)  
  r.style.setProperty('--brand_color_callbuttonbackground', brand_color_callbuttonbackground)
  r.style.setProperty('--brand_color_callbuttonborder', brand_color_callbuttonborder)
  r.style.setProperty('--brand_color_callbuttontext', brand_color_callbuttontext)
  r.style.setProperty('--brand_color_callbuttonhoverbackground', brand_color_callbuttonhoverbackground)
  r.style.setProperty('--brand_color_callbuttonhovertext', brand_color_callbuttonhovertext)

  r.style.setProperty('--header_icon_width', iconwidth)
  r.style.setProperty('--header_icon_height', iconheight)

  function AuthRoute({ children, ...rest }) 
  {
    localStorage.setItem("webclientversion", packageJson.version);

    // App installation behaviour & UI, running SDK's in the background before being able to run their respective embedded function, does nothing the rest of the time.
    const htmlOverride = SpecialEmbeddedBehaviour(embedded);
    if (htmlOverride)
      return <div>
        {htmlOverride}
      </div>

    if (reset === "all")
    {
      localStorage.clear()
      Cookies.remove('webclient', { domain: '.cloudcti.nl' })
    }

    let securityToken = localStorage.getItem("securitytoken")

    //Since we used to use cookies, try to read the cookie if we have no securitytoken
    //If we find it, remove the cookie and save it to the localStorage
    //This can be deleted at a later time when nobody has a cookie anymore
    if (IsEmptyString(securityToken))
    {
      const cookie = Cookies.get("webclient")
      if (cookie)
      {
        securityToken = cookie
        localStorage.setItem("securitytoken", securityToken)
        Cookies.remove('webclient', { domain: '.cloudcti.nl' })
      }
    }
    
    if (!IsEmptyString(securityToken) && !handoverToken)
    {
      return <Route {...rest} render={({ location }) => children }/>
    }
    else
    {   
      if (branding_signinmethod === "gntel")
      {
        return <SigninGntel ProductName={branding_productname} RedirectUrl={WindowUrlWithoutOnetimeParams}/>
      }
      else
      {
        return <Signin ProductName={branding_productname} SigninMethod={branding_signinmethod} RedirectUrl={WindowUrlWithoutOnetimeParams}/>
      }
    }
  }
  
  const page = window.location.pathname.toLowerCase().trim("/")

  // HubSpot secure install flow, step 2 (finalize): this loads inside HubSpot's iframe, where
  // localStorage is a separate, empty partition - no CloudCTI session can exist here. The
  // server-side /oAuth call is validated via the single-use `state` token instead, so this must
  // bypass AuthRoute's signin gate (and the whole Main tree, which assumes a real session)
  // entirely, rather than ever requiring a securitytoken that can't exist in this context.
  if ((embedded ?? "").toLowerCase() === "hubspot" && params.get("step") === "finalize")
  {
    return <EmbeddedHubspot Brand={brand}/>;
  }

  if (((action === "makecall") || (action === "call")) && !IsEmptyString(number))
  {
    const formattedNumber = number
      .replace(/^[a-zA-Z]+:\/*/, '') // remove protocol + : + optional slashes
      .replace(/\/+$/, '');          // remove trailing slashes
    console.log("Calling number",formattedNumber)

    return (
      <Router>
          <Switch>
            <AuthRoute>
              <MakeCall Number={formattedNumber}/>
            </AuthRoute>
          </Switch>
      </Router>
    );
  }
  else
  {
    return (
      <Router>
          <Switch>
            <AuthRoute>
              <Main ProductName={branding_productname} SigninMethod={signinmethod ?? branding_signinmethod} Domain={branding_domain} Embedded={embedded} RedirectUrl={WindowUrlWithoutOnetimeParams} Brand={brand} Nonce={nonce}/>
            </AuthRoute>
          </Switch>
      </Router>
    );
  }
}

export default App;